import { t, type I18nLocale, type WithI18nLocale } from '@ardoq/i18n';

const getOutOfSyncMessages = (i18nLocale: I18nLocale) => ({
  incompatible: t(
    i18nLocale,
    'appContainer:scenarioRelated.outOfSyncMetamodel1',
    'The metamodel of the scenario is incompatible with the metamodel in the mainline.'
  ),
  resolution: t(
    i18nLocale,
    'appContainer:scenarioRelated.outOfSyncMetamodel2',
    'To get the metamodels back to a compatible state, please use the scenario merge functionality.'
  ),
});

export const ScenarioOutOfSyncPopoverContent = ({
  i18nLocale,
}: WithI18nLocale) => {
  const { incompatible, resolution } = getOutOfSyncMessages(i18nLocale);
  return (
    <div style={{ width: 190 }}>
      <p>{incompatible}</p>
      {resolution}
    </div>
  );
};

export const getScenarioOutOfSyncPopoverText = (
  i18nLocale: I18nLocale
): string => {
  const { incompatible, resolution } = getOutOfSyncMessages(i18nLocale);
  return `${incompatible}\n\n${resolution}`;
};
